module.exports = __webpack_public_path__ + "static/media/logo.198051fc.png";